import { render, staticRenderFns } from "./GrupoNotificacaoSelect.vue?vue&type=template&id=83d53a00&"
import script from "./GrupoNotificacaoSelect.vue?vue&type=script&lang=js&"
export * from "./GrupoNotificacaoSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports